export default {
  actions: {
    REGISTER_USER: 'registerUser',
    GENERATE_CODES: 'generateCodes',
    CODE_USED: 'codeUsed',
    RESEND_VERIFICATION: 'resendVerification',
    CHANGE_PASSWORD: 'changePassword',
    CONFIRM_PASSWORD_CHANGE: 'confirmPasswordChange',
    FORGOT_PASSWORD: 'forgotPassword',
  },
  mutations: {
    REGISTERING_USER: 'registeringUser',
    USER_REGISTERED: 'userRegistered',
    REGISTERING_USER_FAILED: 'registeringUserFailed',
    GENERATING_CODES: 'generatingCodes',
    RECEIVE_CODES: 'receiveCodes',
    CODE_GENERATION_ERROR: 'codeGenerationError'
  },
  getters: {
    GET_REGISTER_STATUS: 'getRegisterStatus',
    LOGGED_IN: 'loggedIn',
    GET_CODES_STATUS: 'getCodesStatus',
    GET_CODES: 'getCodes',
    IS_ADMIN: 'isAdmin',
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js